import { useToast } from '@chakra-ui/react';

import { API_IDS, ASSIGNMENT_END_REASON } from '../../constants';
import { msToTime } from '../../utils';
import { useUpdateTimeRemaining } from '../../queries';
import { useCountdownTimer } from '../useCountdownTimer';
import { useContextEffect, useStableCallback } from '../useBetterHooks';
import { useDispatch } from 'react-redux';
import {
  incrementFailureCount,
  resetAllFailureCounts
} from '../../redux/reducers/api-call-state-reducer';

const useStudentAssignmentTimer = ({
  enabled = false,
  timeRemaining,
  studentAssignmentId,
  onEndTest
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const { mutate: updateTimeRemaining } = useUpdateTimeRemaining(studentAssignmentId);
  const onTick = (remainingTime) => {
    if ((remainingTime / 1000) % 30 === 0) {
      // Updating time to server every 30 seconds
      updateTimeRemaining(remainingTime, {
        onSuccess: () => {
          dispatch(resetAllFailureCounts());
        },
        onError: (err) => {
          console.log('OnError', err);
          const message = err?.message?.toLowerCase?.() ?? '';
          const code = err?.code;
          if (
            !navigator.onLine ||
            message.includes('timeout') ||
            message.includes('network') ||
            code === 'ERR_NETWORK' ||
            code === 'ECONNABORTED'
          ) {
            dispatch(incrementFailureCount(API_IDS.TIMER_SYNC));
          }
        }
      });
    }
  };

  const onExpire = useStableCallback(() => {
    toast({
      title: 'Time over!',
      status: 'warning',
      isClosable: true
    });
    onEndTest(ASSIGNMENT_END_REASON.TIME_OVER);
  });

  const { countdown, start, pause } = useCountdownTimer({
    initialTime: timeRemaining ?? 0,
    autostart: false,
    onTick,
    onExpire
  });

  useContextEffect({
    deps: [timeRemaining, enabled],
    ctx: { timeRemaining, enabled, start },
    cb: (ctx) => {
      if (ctx.enabled) {
        ctx.start(ctx.timeRemaining);
      }
    }
  });

  return { countdown: msToTime(countdown), pause, start };
};

export default useStudentAssignmentTimer;
